module.exports = function errorPage(payload) {
 const status = payload && [400, 403, 404, 500].indexOf(payload.status) >= 0 ? payload.status : 404;
 return { status, title: status === 400 ? 'Unable to create your brew' : status === 403 ? 'Access denied' : status === 500 ? 'Something went wrong' : 'Page not found',
  messages: status === 400 && payload && Array.isArray(payload.messages) ? payload.messages.filter(message => typeof message === 'string') : [],
  recovery: status === 400 ? '/dashboard#/new' : '/dashboard' };
};
